"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genYearsArray = void 0;
var genYearsArray = function (fromYr, toYr) {
    var yrsAry = [];
    for (var i = fromYr; i <= toYr; i++) {
        yrsAry.unshift(i.toString());
    }
    return yrsAry.map(function (d) { return ({ display: d, value: d }); });
};
exports.genYearsArray = genYearsArray;
